import React, { useState, useEffect } from 'react';

import CompatioAnalytics from '../../api/CompatioAnalytics';
import DCContainer from '../dynamic-configurator/dc-container/DcContainer';
import { assign as _assign, get as _get } from 'lodash-es';
// import MRFCData from '../../api/mrfc_sku_map__rods_lines_reels.json';
import CompatibleWithHelper from '../utils/CompatibleWithHelper';

import DCABSdataApi from '../../api/DCABSdataApi';

const trackAnchorClick = (data, modelId, modelShortName) => {
  CompatioAnalytics.track(
    CompatioAnalytics.events.dcAnchorClick,
    {
      baseFinalProductID: data.productSku ? data.productSku : null,
      baseParentProductID: data.productSku ? data.productId : null,
      baseFinalProductName: data.productSku ? data.productName : null,
      clickAction: CompatioAnalytics.clicks.dcGotoWidget,
    },
    'SmartBuilder',
    'V2',
    modelId,
    modelShortName
  );
  // console.log(data,'data')
};

const DcConfigs = _get(window, 'compatioConfig.compatibleProducts.dcConfig');

const IsProductSpecificDC = _get(
  window,
  'compatioConfig.compatibleProducts.isProductSpecificDC'
)
  ? _get(window, 'compatioConfig.compatibleProducts.isProductSpecificDC')
  : false;

const IsPlatformShopify =
  typeof _get(window, 'compatioConfig.shopify') === 'object';
const propsNew = [];
const BuildDCAnchor = props => {
  const modelIdJson = props.modelIdJson;
  let variantMap = [];
  let storeName = _get(window, 'compatioConfig.shopify.baseUrl');
  // alert(true)
  // variantMap = IsPlatformShopify
  //   ? MRFCData.find(each => each.store === storeName).skumap
  //   : [];
  if (IsProductSpecificDC == true) {
    variantMap = modelIdJson.builderModels;
  }

  const [firsAPiStore, setFirsAPiStore] = useState(false);
  const [isDcShow, setIsDcShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [dcDisplay, setDcDisplay] = useState('dc-container-hide');
  const [modelId, setModelId] = useState(
    _get(window, 'compatioConfig.shopify.modelId')
      ? _get(window, 'compatioConfig.shopify.modelId')
      : _get(window, 'compatioConfig.magento.modelId')
  );
  // const [modelId, setModelId] = useState(
  //   _get(window, 'compatibleProducts.dcConfig')
  // );
  // /window.compatioConfig.compatibleProducts.dcConfig
  const [dcConfigDetails, setDCConfigDetails] = useState(DcConfigs[0].details);
  const [preSelectedData, setPreSelectedData] = useState([]);
  const [noSelectedData, setnoSelectedData] = useState(false);
  const [dataBlankData, setdataBlankData] = useState(false);
  const [OpenPopReels, setOpenPopReels] = useState(false);
  const [preFiltersData, setPreFiltersData] = useState([]);
  const [preCatOneSection, setPreCatOneSection] = useState([]);
  const [preCatTwoSection, setPreCatTwoSection] = useState([]);
  const [firstTimeload, setfirstTimeload] = useState(false);
  const [selectDataAvailable, setSelectDataAvailable] = useState(false);
  const [newCat, setNewCat] = useState(false);

  const [loadCeckFirst, setloadCeckFirst] = useState(false);

  props = JSON.parse(JSON.stringify(props));
  const handleChangevariant = variantSku => {
    props.productSku = variantSku;
    const filterModelId = modelIdJson.builderModels[0];
    if (filterModelId != undefined) {
      fetchDataFirstTime(props, modelId);
    }
  };
  window.compatioConfig.compatibleProducts.methods.handleChangevariant = handleChangevariant;
  // console.log(props, 'props');
  const fetchDataFirstTime = async (props, modelId) => {
    if (modelIdJson.builderModels[0] != undefined) {
      if (props.productSku != undefined && props.productSku != '') {
        // alert(props.productSku);
        const dfs = await DCABSdataApi.getCategoryDataByProductSku(
          [props.productSku],
          '',
          '',
          modelIdJson.builderModels[0]
        );
        setFirsAPiStore(dfs);
        let catNameSet = [];
        if (dfs.results && Object.keys(dfs.results).length > 0) {
          console.log(window.$('li.buildanoutfit')[0]);
          if (window.$('li.buildanoutfit')[0]) {
            // Element exists, make it visible
            window.$('li.buildanoutfit').attr('style', 'display: flex');
          }
        }
        if (dfs.meta.selection_details != undefined) {
          for (const [key, value] of Object.entries(
            dfs.meta.selection_details
          )) {
            // console.log(key,'key')
            // console.log(key.split('__')[2], value,'gasdf',outfitList,catNameSet)
            catNameSet.push(key.split('__')[2]);
          }
          // outfitList[0].categoryCurrent = catNameSet[0];
          // outfitList[0].categoryName = catNameSet[0];
          // propsNew = 'fsd';
          // console.log(catNameSet,'catNameSet',outfitList[0].categoryCurrent)
          // console.log('catNameSet', catNameSet);
          // propsNew.push(catNameSet)

          propsNew.push(props);
          propsNew[0].productType = catNameSet[0];
          propsNew[0].modelShortName =
            dfs.meta.builder.model.builder_short_name;
          propsNew[0].modelID = dfs.input.builder_model;
          props.modelShortName = dfs.meta.builder.model.builder_short_name;
          props.modelID = dfs.input.builder_model;
          setTimeout(function() {
            // console.log('checking first', propsNew);
            setloadCeckFirst(true);
          }, 1000);
        }
        // setOutfitList(outfitList);
      }
    }
  };

  const forSortName = async (props, modelId) => {
    if (props.productSku == undefined && props.productSku != '') {
      // alert(props.productSku);
      const dfs = await DCABSdataApi.getCategoryDataByProductSku(
        [props.productSku],
        '',
        '',
        props.dcConfig[0].modelId
      );
      setFirsAPiStore(dfs);
      let catNameSet = [];
      if (dfs.results && Object.keys(dfs.results).length > 0) {
        console.log(window.$('li.buildanoutfit')[0]);
        if (window.$('li.buildanoutfit')[0]) {
          // Element exists, make it visible
          window.$('li.buildanoutfit').attr('style', 'display: flex');
        }
      }
      if (dfs.meta.selection_details != undefined) {
        for (const [key, value] of Object.entries(dfs.meta.selection_details)) {
          // console.log(key,'key')
          // console.log(key.split('__')[2], value,'gasdf',outfitList,catNameSet)
          catNameSet.push(key.split('__')[2]);
        }

        // outfitList[0].categoryCurrent = catNameSet[0];
        // outfitList[0].categoryName = catNameSet[0];
        // propsNew = 'fsd';
        // console.log(catNameSet,'catNameSet',outfitList[0].categoryCurrent)
        // console.log('catNameSet', catNameSet);
        // propsNew.push(catNameSet)

        propsNew.push(props);
        propsNew[0].productType = catNameSet[0];
        propsNew[0].modelShortName = dfs.meta.builder.model.builder_short_name;
        propsNew[0].modelID = dfs.input.builder_model;
        props.modelShortName = dfs.meta.builder.model.builder_short_name;
        props.modelID = dfs.input.builder_model;
        setTimeout(function() {
          // console.log('checking first', propsNew);
          // setloadCeckFirst(true);
        }, 1000);
      }
      // setOutfitList(outfitList);
    }
  };

  useEffect(() => {
    if (props.productSku != undefined) {
      fetchDataFirstTime(props, modelId);
    } else {
      forSortName(props);
      setloadCeckFirst(true);
    }
  }, []);

  // useEffect(()=>{
  //   // if(loadCeckFirst == true){
  //   //   console.log('fad',propsNew)
  //   // }
  // },[loadCeckFirst])

  useEffect(() => {
    if (isDcShow == true) {
      let showDataForBuilder =
        IsProductSpecificDC == true
          ? props.productSku
            ? propsNew[0]
            : props
          : props;
      if (
        firsAPiStore != false &&
        Object.keys(firsAPiStore.results).length != 0
      ) {
        // console.log(propsNew[0].modelShortName,props.modelShortName,'IsProductSpecificDC',firsAPiStore.meta.builder.model.builder_short_name)
        // console.log("dfs.results is not empty",firsAPiStore.meta.builder.model);
        CompatioAnalytics.track(
          CompatioAnalytics.events.RecShown,
          {
            baseFinalProductID: showDataForBuilder.productSku,
            baseParentProductID: showDataForBuilder.productSku,
            baseFinalProductName: showDataForBuilder.productName,
          },
          'SmartBuilder',
          'V2',
          props.modelIdJson.builderModels[0],
          firsAPiStore.meta.builder.model.builder_short_name //modelShortName this attribute row pass only in ars that,s why i keep this blank in builder
        );
      }
    }
  }, [isDcShow]);

  useEffect(() => {
    //https://community.shopify.com/c/storefront-api-and-sdks/graphql-query-product-by-product-handle-exact-match/td-p/892478
    //https://community.shopify.com/c/shopify-apis-and-sdks/list-product-variants-from-different-locations-with-graphql/td-p/595551
    //https://www.shopify.in/partners/blog/multi-location_and_graphql

    if (loadCeckFirst == true) {
      const hashObject = CompatibleWithHelper.getUrlHashObject();

      if (hashObject !== undefined) {
        if (hashObject.currentcat !== undefined) {
          let currentCatNew = JSON.parse(
            Buffer.from(hashObject.currentcat, 'base64')
          );
          setNewCat(currentCatNew);
        }

        if (hashObject.selectedData != 'nodata') {
          if (
            hashObject.selectedData != undefined &&
            hashObject.selectedData != ''
          ) {
            setSelectDataAvailable(true);
            setdataBlankData(true);
            let preSelection = JSON.parse(
              Buffer.from(hashObject.selectedData, 'base64').toString()
            );

            // console.log(preSelection, 'preSelection');
            //  preSelection.map(e=>{console.log(e.variant_id,'eeeee')});

            preSelection.forEach(e => {
              const productQuery = () => `
              query {
                products(first: 100,  query: "'${e.variant_id}'") {
                  edges {
                    node {
                      id
                      variants(first: 50) {
                        edges {
                          node {
                            id
                            availableForSale 
                            currentlyNotInStock 
                          }
                        }
                      }
                    }
                  }
                }
              }
              `;

              const GRAPHQL_BODY = () => {
                return {
                  method: 'POST',
                  headers: {
                    'X-Shopify-Storefront-Access-Token':
                      window.compatioConfig.shopify
                        .shopifyStorefrontAccessToken,
                    'Content-Type': 'application/graphql',
                  },
                  body: productQuery(),
                };
              };

              const filtersProductPre = [];
              const filtersProductPreVarient = [];

              fetch(
                window.compatioConfig.shopify.apiEndpointUrl,
                GRAPHQL_BODY()
              )
                .then(res => res.json())
                .then(products => {
                  filtersProductPre.push(products.data.products.edges);
                  filtersProductPreVarient.push(
                    filtersProductPre[0].map(e => e.node.variants.edges)
                  );
                  filtersProductPreVarient[0]
                    .map(e => e)
                    .forEach(element => {
                      element.forEach(element => {
                        let dat = Buffer.from(
                          element.node.id,
                          'base64'
                        ).toString('ascii');
                        let dats = dat.split('/');
                        if (dats[4] == e.variant_id) {
                          if (element.node.availableForSale == false) {
                            //  preSelection.push(e)
                            //  console.log(e,'e')
                            preSelection.forEach((ele, index) => {
                              if (ele.variant_id === e.variant_id) {
                                //  delete preSelection[index];
                                preSelection.splice(index);
                              }
                            });
                          }
                        }
                      });
                    });
                });
            });
            const preSelectionNew = [];
            preSelection.forEach((element, index) => {
              if (element.categoryName != 'Backing') {
                //preSelection.splice(index);
                // delete preSelection[index];
                preSelectionNew.push(element);
              } else {
                preSelectionNew.push(element);
              }
              if (element.categoryName === 'Reels') {
                // setOpenPopReels(true);
              }
            });
            // console.log(preSelectionNew, 'preSelectionpreSelection');
            setPreSelectedData(preSelectionNew);
            const urlback = window.location.href;
            const urlbackSet = urlback.split('#')[0];
            var urlmainn = urlback.split('&');
            var urlHome = urlback.split('/')[2];
            setTimeout(function() {
              window.$('.dc-build-anchor-a').click();
              window.$('.builderloading').remove();
              window.history.pushState(
                'forward',
                null,
                // urlbackSet + '#smartBuilder&blank=open'
                urlback.split('/')[0] +
                  '//' +
                  urlHome +
                  '#smartBuilder&blank=open'
              );
              // alert(urlback.split('/')[0]+'//'+urlHome)
            }, 4000);
          }
        } else {
          const urlback = window.location.href;
          const urlbackSet = urlback.split('#')[0];
          var urlmainn = urlback.split('&');
          var urlHome = urlback.split('/')[2];
          // alert(urlback.split('/')[0])
          setTimeout(function() {
            window.$('.dc-build-anchor-a').click();
            window.$('.builderloading').remove();
            window.history.pushState(
              'forward',
              null,
              // urlbackSet + '#smartBuilder&blank=open'
              urlback.split('/')[0] +
                '//' +
                urlHome +
                '#smartBuilder&blank=open'
            );
          }, 4000);
          setPreSelectedData();
          // alert('dont');
          setnoSelectedData(true);
          setdataBlankData(false);
        }

        if (
          hashObject.selectedFilters != undefined &&
          hashObject.selectedFilters != 'undefined'
        ) {
          setSelectDataAvailable(true);
          setdataBlankData(true);
          let decodeFilter = JSON.parse(
            Buffer.from(hashObject.selectedFilters, 'base64').toString('ascii')
          );
          let preFilters = JSON.parse(decodeURI(decodeFilter));

          setPreFiltersData(preFilters);
          setTimeout(function() {
            window.$('.dc-build-anchor-a').click();
            window.$('.builderloading').remove();
          }, 5000);
        }

        if (
          hashObject.catone != undefined &&
          hashObject.catone != 'undefined'
        ) {
          let catone = JSON.parse(
            Buffer.from(hashObject.catone, 'base64').toString()
          );
          // console.log(catone);
          setPreCatOneSection(catone);
        }

        if (
          hashObject.cattwo != undefined &&
          hashObject.cattwo != 'undefined'
        ) {
          let cattwo = JSON.parse(
            Buffer.from(hashObject.cattwo, 'base64').toString()
          );
          // console.log(cattwo);

          setPreCatTwoSection(cattwo);
        }
      }
      if (hashObject.blank === undefined) {
        setfirstTimeload(true);
      }
      // alert(IsProductSpecificDC)
      if (IsProductSpecificDC === true) {
        // console.log(variantMap,'variantMap')
        /*
        if (variantMap.length > 0) {
          const check = variantMap.find(
            each => each.variant_id === propsNew[0].productSku
          );
          if (check) {
            if (check.modelId != undefined) {
              setDCConfigDetails(
                DcConfigs.find(each => each.modelId === check.modelId).details
              );
              setModelId(check.modelId);
            }
            setIsDcShow(true);
          }
        }
        */
        if (modelIdJson.builderModels.length > 0) {
          const check = modelIdJson.builderModels[0];
          if (check) {
            if (check != undefined) {
              setDCConfigDetails(
                DcConfigs.find(each => each.modelId === check).details
              );
              setModelId(check);
            }
            setIsDcShow(true);
          }
        }
      }

      if (IsProductSpecificDC === false) {
        setIsDcShow(true);
      }
      // console.log('fad', propsNew[0]);
    }
  }, [loadCeckFirst]);

  if (isDcShow) {
    setTimeout(function() {
      window.$('.builderloading').remove();
    }, 10000);

    return (
      <>
        <div
          className={`dc-build-anchor-a ${dcDisplay}`}
          onClick={() => {
            // console.log((props.productSku ? (props.productSku ? propsNew[0] : props) : props),'gg')
            // console.log(props.modelIdJson, 'props');
            trackAnchorClick(
              props.productSku
                ? props.productSku
                  ? propsNew[0]
                  : props
                : props,
              props.modelIdJson
                ? props.modelIdJson.builderModels[0]
                : firsAPiStore.input.builder_model,
              firsAPiStore.meta.builder.model.builder_short_name
            );
            document.getElementsByTagName('BODY')[0].className =
              'buildAnOutfit template-product data-dc-anchor';
            setIsOpen(true);
          }}
        >
          <img
            src={dcConfigDetails.imageUrl}
            className="dc-anchor-ff-image"
            alt="Build-Fly-Fishing"
          />
          <div className="dc-anchor-content">
            <div className="contentset-dc-anchor">
              <div className="buildouttext-left">
                <span className="dc-anchor-text">
                  <strong>
                    <span>
                      {dcConfigDetails.title
                        ? dcConfigDetails.title
                        : 'Build It Out'}
                    </span>
                  </strong>
                  <p>
                    {dcConfigDetails.description
                      ? dcConfigDetails.description
                      : 'Browse compatible categories for your products and other accessories'}
                  </p>
                </span>
              </div>

              <div className="builoutbutton-right">
                <button className="anchor btn btn--full">
                  {dcConfigDetails && dcConfigDetails.buttonText
                    ? dcConfigDetails.buttonText
                    : 'BUILD AN OUTFIT'}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <img
          className={`dc-popup-logo ${dcDisplay}`}
          // src="https://d1qrqn8mibon78.cloudfront.net/powered-by-compatio.png"
          src="https://2019testbucket.s3.us-east-2.amazonaws.com/Pictures/logo-compatio-dark.png"
          alt="Compatio"
        /> */}
        <div className="dc-build-anchor">
          <DCContainer
            setfirstTimeload={setfirstTimeload}
            firstTimeload={firstTimeload}
            isOpen={isOpen}
            props={props.productSku ? propsNew[0] : props}
            modelId={modelId}
            setIsOpen={setIsOpen}
            setDcDisplay={setDcDisplay}
            dcConfigDetails={dcConfigDetails}
            preSelectedData={preSelectedData}
            preFiltersData={preFiltersData}
            preCatOneSection={preCatOneSection}
            preCatTwoSection={preCatTwoSection}
            OpenPopReels={OpenPopReels}
            setOpenPopReels={setOpenPopReels}
            noSelectedData={noSelectedData}
            setnoSelectedData={setnoSelectedData}
            dataBlankData={dataBlankData}
            setdataBlankData={setdataBlankData}
            selectDataAvailable={selectDataAvailable}
            setSelectDataAvailable={setSelectDataAvailable}
            setNewCat={setNewCat}
            newCat={newCat}
            firsAPiStore={firsAPiStore}
          />
        </div>
      </>
    );
  } else return null;
};

export default BuildDCAnchor;
